// extracted by mini-css-extract-plugin
export default {"banner":"LocalDevEnvironmentBanner_banner__xorwJ"};